// extracted by mini-css-extract-plugin
export default {"map":"MapSection_map__LKFC0","mapLabel":"MapSection_mapLabel__7oNhO","clickLayer":"MapSection_clickLayer__SkLUy"};